/* eslint-disable no-continue */
import _ from 'lodash';
import api from '../../utils/api';

export const SET_ALLOW_CHECKIN = 'SET_ALLOW_CHECKIN';
export const SET_VISITOR_NAME = 'SET_VISITOR_NAME';
export const SET_LOADING = 'SET_LOADING';
export const SET_GO_TO = 'SET_GO_TO';

export const setAllowCheckin = matches => ({
  type: SET_ALLOW_CHECKIN,
  matches,
});

export const setVisitorName = name => ({
  type: SET_VISITOR_NAME,
  name,
});

export const setLoadingVisitorAction = isLoading => ({
  type: SET_LOADING,
  isLoading,
});

export const setGoTo = goTo => ({
  type: SET_GO_TO,
  goTo,
});

/**
 * Before matching the given first name and last name with all the heroes from the office,
 * this method also checks if the visitor has already checked in to the building
 * @param {Object} submitData
 * @returns Promise
 */
export const allowCheckin = submitData => dispatch => {
  dispatch(setLoadingVisitorAction(true));
  return new Promise((resolve, reject) => {
    api
      .get(`visitors/heroes/allowcheckin/fname/${submitData.heroFirstName}/lname/${submitData.heroLastName}/office/${submitData.officeId}/phone/${submitData.visitorPhoneNumber}`)
      .then(data => {
        dispatch(setAllowCheckin(_.get(data, 'data.data')));
        resolve();
      })
      .catch(({ response }) => {
        reject(response.data.error);
      })
      .finally(() => {
        dispatch(setLoadingVisitorAction(false));
      });
  });
};

export const checkinVisitor = submitData => dispatch => {
  dispatch(setLoadingVisitorAction(true));
  return new Promise((resolve, reject) => {
    api
      .post(`/visitors/checkin`, submitData)
      .then(data => {
        dispatch(setVisitorName(_.get(data, 'data.visitor')));
        resolve();
      })
      .catch(({ response }) => {
        reject(response.data.error);
      })
      .finally(() => {
        dispatch(setLoadingVisitorAction(false));
      });
  });
};

export const checkoutVisitor = phoneNumber => dispatch => {
  dispatch(setLoadingVisitorAction(true));
  return new Promise((resolve, reject) => {
    api
      .post(`/visitors/checkout`, phoneNumber)
      .then(({ data = {} }) => {
        dispatch(setVisitorName(_.get(data, 'data.visitor')));
        resolve();
      })
      .catch(({ response }) => {
        reject(response.data.error);
      })
      .finally(() => {
        dispatch(setLoadingVisitorAction(false));
      });
  });
};
